import {Component, inject, PLATFORM_ID} from '@angular/core';
import {ToastModule} from 'primeng/toast';
import {AutofocusDirective} from '@abydos-angular/core';
import {isPlatformBrowser, NgClass, NgStyle} from '@angular/common';
import {MessageService} from 'primeng/api';
import {ButtonDirective, ButtonLabel, ButtonModule} from 'primeng/button';
import {ConfirmDialog} from 'primeng/confirmdialog';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Component({
    selector: 'app-primeng-service-handler',
    imports: [ToastModule, AutofocusDirective, NgStyle, ButtonDirective, ButtonLabel, ConfirmDialog, NgClass, ButtonModule],
    standalone: true,
    templateUrl: './primeng-service-handler.component.html',
})
export class PrimeNGServiceHandlerComponent {
    private platformId = inject(PLATFORM_ID);
    isBrowser = isPlatformBrowser(this.platformId);

    constructor(private messageService: MessageService) {
    }

    confirmDialogWidth(cd2: ConfirmDialog): number {
        return (isNotNullOrUndefined(cd2.option('message')) ? cd2.option('message').length * 9 : 200);
    }

    close() {
        this.messageService.clear();
    }
}
